import { render, staticRenderFns } from "./RightList.vue?vue&type=template&id=207a7f93&scoped=true"
import script from "./RightList.vue?vue&type=script&lang=js"
export * from "./RightList.vue?vue&type=script&lang=js"
import style0 from "./RightList.vue?vue&type=style&index=0&id=207a7f93&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a7f93",
  null
  
)

export default component.exports